<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <el-button @click="addRechargeOpenBtn" size="small" type="primary" class="bg-theme">添加金额</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="salePrice"
            label="售价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="isGiftGive"
            label="参与会员赠送">
            <template slot-scope="scope">
              <span v-if="scope.row.isGiftGive === 1">参与</span>
              <span v-else>不参与</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 添加充值金额弹窗 -->
    <el-dialog
      title="添加充值金额"
      :visible.sync="addRechargeShow"
      width="960px">
      <el-form :model="addRechargeForm" label-width="140px">
        <el-form-item label="售价：">
          <el-input style="width: 420px;" v-model="addRechargeForm.salePrice" placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <el-form-item label="参与会员赠送：">
          <el-radio-group v-model="addRechargeForm.isGiftGive">
            <el-radio :label="1">参与</el-radio>
            <el-radio :label="0">不参与</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否开启：" prop="status">
          <el-switch
            v-model="addRechargeForm.status"
            active-color="#1890FF"
            inactive-color="#CCCCCC">
          </el-switch>
        </el-form-item>
        <el-form-item label="排序：">
          <el-input style="width: 420px;" v-model="addRechargeForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addRechargeSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { queryMoneyRechargePageList, removeMoneyRechargeById, saveMoneyRecharge, updateMoneyRecharge, fetchMoneyRechargeDetailById, enableMoneyRecharge } from '@/api/balance'
export default {
  name: 'RechargeAmount',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      // 添加充值金额弹窗
      addRechargeShow:false,
      addRechargeForm:{
        salePrice:'',
        isGiftGive:1,
        status:false,
        sort:''
      },
      dataId:''
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let page = that.currentPage
      queryMoneyRechargePageList({ pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 添加充值金额弹窗-打开操作
    addRechargeOpenBtn(){
      this.dataId = '';
      this.addRechargeForm.salePrice = '';
      this.addRechargeForm.isGiftGive = 1;
      this.addRechargeForm.status = false;
      this.addRechargeForm.sort = '';
      this.addRechargeShow = true;
    },
    // 添加/编辑充值金额弹窗-保存操作
    addRechargeSaveBtn(){
      var that = this;
      var dataId = that.dataId;
      var addRechargeForm = that.addRechargeForm;
      let status = that.addRechargeForm.status ? 1 : 0;
      let sort = that.addRechargeForm.sort === '' ? 1 : that.addRechargeForm.sort;
      if(addRechargeForm.salePrice == ''){
        this.$message.error('请输入充值金额');
        return false;
      }
      let passData = {
        salePrice:addRechargeForm.salePrice,
        isGiftGive:addRechargeForm.isGiftGive,
        status:status,
        sort:sort
      }
      that.fullscreenLoading = true;
      if(dataId == ''){
        saveMoneyRecharge(passData).then((res) => {
            that.backDataFun(res);
        })
      }else{
        passData.id = dataId;
        updateMoneyRecharge(passData).then((res) => {
            that.backDataFun(res);
        });
      }

    },
    backDataFun(res){
      var that = this
      that.fullscreenLoading = false
      if (res.errorCode === '0000') {
        that.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.addRechargeForm.salePrice = '';
            that.addRechargeForm.isGiftGive = 1;
            that.addRechargeForm.status = false;
            that.addRechargeForm.sort = '';
            that.addRechargeShow = false;
            that.getInfoList();
          }
        })
      }
      if (res.errorCode === '1001') {
        that.$message.error(res.msg)
      }
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      enableMoneyRecharge({ id: infoId}).then((res) => {
        if (res.errorCode === '0000') {
          that.$message({
            message: res.msg,
            type: 'success',
            onClose () {}
          })
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
    },
    /* 编辑 */
    editBtn (infoId) {
      var that = this;
      that.dataId = infoId;
      fetchMoneyRechargeDetailById({ id: infoId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.addRechargeForm.salePrice = data.salePrice
          that.addRechargeForm.isGiftGive = data.isGiftGive
          that.addRechargeForm.status = data.status == 1 ? true : false
          that.addRechargeForm.sort = data.sort
          that.addRechargeShow = true
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeMoneyRechargeById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/balance/RechargeAmount.vue